import { type FC } from 'react'
import { useIntl } from 'react-intl'

import { directContactFormIsPhoneNumberValid } from '../../model/directContactFormIsPhoneNumberValid'

import { DirectContactFormTextField } from './DirectContactFormTextField'

export const DirectContactFormPhoneNumberField: FC<{
  clearErrorOnClick?: boolean
}> = ({ clearErrorOnClick }) => {
  const intl = useIntl()
  const invalidPhoneMessage = intl.formatMessage({
    id: 'address.error.phone.invalid',
  })

  return (
    <DirectContactFormTextField
      autoComplete="tel"
      clearErrorOnClick={clearErrorOnClick}
      data-qa-id="contact-form-phoneNumber-field"
      label={intl.formatMessage({ id: 'direct.contact.form.phone.number' })}
      name="phoneNumber"
      rules={{
        validate: (value) =>
          !value ||
          directContactFormIsPhoneNumberValid(value) ||
          invalidPhoneMessage,
      }}
      type="tel"
    />
  )
}
